import { useQuery } from '@apollo/client';

import { TINDER_SUPER_LIKED_USERS } from '../graphql/query/tinderSuperLikedUsersQuery.graphql';

export const useTinderSuperLikedUsersQuery = (eventId: string) => {
  return useQuery(TINDER_SUPER_LIKED_USERS, {
    variables: { eventId },
    fetchPolicy: 'cache-and-network',
  });
};
